import styled from "styled-components";

import { mixins } from "@similarweb/styles";

export const StyledIntegrationTag = styled.div.attrs<{ "data-automation"?: string }>((props) => ({
    "data-automation": "integration-tag",
}))`
    border-radius: 4px;
    flex-shrink: 0;
    padding: 4px 16px;
    cursor: pointer;

    & a,
    & span {
        ${mixins.setFontVariant("captionTitle")};
    }
`;
